export default {
      id: "color_mobile-usage",
      viewBox: "0 0 154 211.9",
      url: __webpack_public_path__ + "sprite.svg#color_mobile",
      toString: function () {
        return this.url;
      }
    }